// extracted by mini-css-extract-plugin
export default {"btn":"WhiteBtnSmall_btn__S0dxr","digit":"WhiteBtnSmall_digit__9rN6w","dot":"WhiteBtnSmall_dot__0dhTT"};